import { render, staticRenderFns } from "./homeworkStatis.vue?vue&type=template&id=ad80c038&scoped=true"
import script from "./homeworkStatis.vue?vue&type=script&lang=js"
export * from "./homeworkStatis.vue?vue&type=script&lang=js"
import style0 from "./homeworkStatis.vue?vue&type=style&index=0&id=ad80c038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad80c038",
  null
  
)

export default component.exports